import { useQuery } from '@tanstack/react-query'
import React from 'react'

import { getPeriods } from '../../api/periods/get-periods'
import { PeriodTypes } from '../../lib/types/models/period/period'
import LoadingScreen from '../elements/loading/loading-screen'

export type WithPeriodsProps = {
  periods?: PeriodTypes.Full[]
}

// HOC that sets the theme and renders the wrapped component
function withPeriods<T extends object>(WrappedComponent: React.ComponentType<T>) {
  return (props: T) => {
    // Render the wrapped component with the rest of the props
    const { data, isPending } = useQuery({
      queryKey: ['periods'],
      queryFn: () => getPeriods({ version: 'BASIC' })
    })
    if (isPending) return <LoadingScreen />
    return <WrappedComponent periods={data?.data} {...props} />
  }
}

export default withPeriods
